// extracted by mini-css-extract-plugin
export default {"form":"style_form__5umXV","title":"style_title__40LNW","resend":"style_resend__yHmcd"};